import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const CookiesComponent = () => {
  const [hasConsent, setHasConsent] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const consent = Cookies.get("tech_cookies");
    if (consent === "true") {
      setHasConsent(true);
    }
  }, []);

  const acceptCookies = () => {
    Cookies.set("tech_cookies", "true", { expires: 365 });
    setHasConsent(true);
  };

  if (hasConsent) {
    return null;
  }

  return (
    <div className="fixed bg-opacity-95 font-roboto bottom-0 inset-x-0 bg-custom-blue h-[18rem] md:h-[16rem] gap-4 z-50">
      <div className="p-4 text-custom-white flex md:flex-row flex-col md:w-3/4 w-full justify-self-center h-full justify-between">
        <div className="flex flex-col md:w-3/4 w-full md:pt-4">
          <h2 className="font-semibold mb-6 md:text-2xl text-lg border-l-4 border-custom-salmon pl-2 w-full">
            Cookies{" "}
          </h2>
          <div className="flex flex-col text-sm 2xl:text-lg md:text-base gap-2">
            <p>
              Webová stránka rentkos.sk používa technické cookies. Sú nevyhnutné
              pre základné funkcie ako navigácia, bezpečnosť alebo zapamätanie
              si vašich nastavení.
            </p>
            <p>
              Kliknutím na "Súhlasím" súhlasíte s používaním týchto cookies.
              Viac informácií nájdete v sekcii{" "}
              <span
                className="underline hover:cursor-pointer hover:text-custom-salmon"
                onClick={() => navigate("/sukromie")}
              >
                Ochrana súkromia.
              </span>
            </p>
          </div>
        </div>

        <div className="flex h-full items-center justify-center">
          <button
            onClick={acceptCookies}
            className="text-sm 2xl:text-lg md:text-base bg-custom-salmon hover:bg-custom-red-light text-custom-gray-100 hover:text-custom-atrament font-semibold py-2 px-4 rounded md:w-48 w-full h-auto md:h-[2.8rem]"
          >
            Súhlasím
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiesComponent;
